import { render, staticRenderFns } from "./ProductDetailsXD.vue?vue&type=template&id=546acb78&scoped=true&"
import script from "./ProductDetailsXD.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsXD.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsXD.vue?vue&type=style&index=0&id=546acb78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546acb78",
  null
  
)

export default component.exports